import {Injectable} from '@angular/core';
import {
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {tap} from 'rxjs/operators';
import {OfflineDetector} from '../services/offline-detector';
import {ConsoleLogger} from '../singletons/console-logger';

@Injectable()
export class CacheInterceptor implements HttpInterceptor {

  constructor(private offlineDetector: OfflineDetector) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    // pass along non-cacheable requests and invalidate cache
    if (req.method !== 'GET') {
      ConsoleLogger.warn(`Invalidating cache: ${req.method} ${req.url}`);
      return next.handle(req);
    }

    // attempt to retrieve a cached response
    const cachedResponse = JSON.parse(localStorage.getItem(req.url));
    // return cached response if offline
    if (cachedResponse && (!navigator.onLine || this.offlineDetector.offlineUse)) {
      ConsoleLogger.warn(`Returning a cached response: ${cachedResponse.url}`, cachedResponse);
      return of(new HttpResponse(cachedResponse));
    }

    // send request to server and add response to cache
    return next.handle(req).pipe(
      tap(event => {
        if (event instanceof HttpResponse) {
          ConsoleLogger.info('Adding item to cache', req.url);
          try {
            localStorage.setItem(req.url, JSON.stringify(event));
          } catch (e) {
            localStorage.removeItem(req.url);
          }
        }
      })
    );
  }
}
